import { combineReducers } from "@reduxjs/toolkit";
import downloadPdf from "./download-pdf";

const downloadPdfReducer = combineReducers({
  downloadPdf,
});

export default downloadPdfReducer;
